import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import LoginPage from "./Pages/LoginPage";
import Process from "./Pages/Process";
import Unauthorized from "./Pages/unauth";
import FormSubmitted from "./Pages/formSubmitted";
import ExistingPatientRegistrationForms from "./Pages/Forms/Patient Registration Forms/ExistingPatReg";
import PatientRegistrationForms from "./Pages/Forms/Patient Registration Forms/newPatientReg";
import ContextNotFound from "./Pages/ContextNotFound";
import NotFound from "./Pages/notFound"


const App = () => {
  return (
      <Router>
      <Routes>
          <Route path="/" element={<LoginPage />} />
          <Route path="/unauth" element={<Unauthorized />} />
          <Route path="/process" element={<Process />} />
          <Route path="/form-submission-success" element={<FormSubmitted />} />
          <Route path="/context-not-found" element={<ContextNotFound />} />
          <Route path="/existing-patient-registration-form" element={<ExistingPatientRegistrationForms />} />
          <Route path="/patient-registration-form" element={<PatientRegistrationForms />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </Router>
  );
};

export default App;
